import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'

Vue.use(VueRouter)

// const lazyload = component => () => import(`./views/${component}.vue`)

const routes = [
  {
    path: '/index',
    name: 'Index',
    component: Index
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import(/* webpackChunkName: "products" */ '../views/Products.vue')
  },
  {
    path: '/resolution',
    name: 'Resolution',
    component: () => import(/* webpackChunkName: "resolution" */ '../views/Resolution.vue')
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import(/* webpackChunkName: "support" */ '../views/TechSupport.vue')
  },
  {
    path: '/partners',
    name: 'Partners',
    component: () => import(/* webpackChunkName: "partners" */ '../views/Partners.vue')
  },
  {
    path: '/cloundMonitor',
    name: 'cloundMonitor',
    component: () => import(/* webpackChunkName: "MonitorSystem/CloundSystem" */ '../views/MonitorSystem/CloundMonitor.vue')
  },
  {
    path: '/configMonitor',
    name: 'configMonitor',
    component: () => import(/* webpackChunkName: "MonitorSystem/ConfigSystem" */ '../views/MonitorSystem/ConfigMonitor.vue')
  },
  {
    path: '/internetMonitor',
    name: 'internetMonitor',
    component: () => import(/* webpackChunkName: "MonitorSystem/InternetSystem" */ '../views/MonitorSystem/InternetMonitor.vue')
  },
  {
    path: '/ipMonitor',
    name: 'ipMonitor',
    component: () => import(/* webpackChunkName: "MonitorSystem/InternetSystem" */ '../views/MonitorSystem/IpMonitor.vue')
  },
  {
    path: '/serviceMonitor',
    name: 'serviceMonitor',
    component: () => import(/* webpackChunkName: "MonitorSystem/ServiceSystem" */ '../views/MonitorSystem/ServiceMonitor.vue')
  },
  {
    path: '/storageMonitor',
    name: 'storageMonitor',
    component: () => import(/* webpackChunkName: "MonitorSystem/ServiceSystem" */ '../views/MonitorSystem/StorageMonitor.vue')
  },
  {
    path: '/virtualMonitor',
    name: 'virtualMonitor',
    component: () => import(/* webpackChunkName: "MonitorSystem/VirtualSystem" */ '../views/MonitorSystem/VirtualMonitor.vue')
  },
  {
    path: '/webMonitor',
    name: 'webMonitor',
    component: () => import(/* webpackChunkName: "MonitorSystem/WebSystem" */ '../views/MonitorSystem/WebMonitor.vue')
  },
  {
    path: '/engineMonitor',
    name: 'engineMonitor',
    component: () => import(/* webpackChunkName: "MonitorSystem/EngineMonitor" */ '../views/MonitorSystem/EngineMonitor.vue')
  },
  {
    path: '/log',
    name: 'log',
    component: () => import(/* webpackChunkName: "MonitorSystem/WebSystem" */ '../views/MonitorSystem/log.vue')
  },
  {
    path: '/network',
    name: 'network',
    component: () => import(/* webpackChunkName: "MonitorSystem/WebSystem" */ '../views/MonitorSystem/network.vue')
  },
  {
    path: '/train_zcu',
    name: 'train_zcu',
    component: () => import(/* webpackChunkName: "TrainZCU" */ '../views/Training/TrainZCU.vue')
  },
  {
    path: '/train_zcs',
    name: 'train_zcs',
    component: () => import(/* webpackChunkName: "TrainZCS" */ '../views/Training/TrainZCS.vue')
  },
  {
    path: '/train_zcp',
    name: 'train_zcp',
    component: () => import(/* webpackChunkName: "TrainZCP" */ '../views/Training/TrainZCP.vue')
  },
  {
    path: '/train_zce',
    name: 'train_zce',
    component: () => import(/* webpackChunkName: "TrainZCE" */ '../views/Training/TrainZCE.vue')
  },
  {
    path: '/resolution_case1',
    name: 'case1',
    component: () => import(/* webpackChunkName: "resolution/case1" */ '../views/Resolutions/Resolution1.vue')
  },
  {
    path: '/resolution_case2',
    name: 'case2',
    component: () => import(/* webpackChunkName: "resolution/case2" */ '../views/Resolutions/Resolution2.vue')
  },
  {
    path: '/operations_itsm',
    name: 'itsm',
    component: () => import(/* webpackChunkName: "resolution/case1" */ '../views/Operations/itsm.vue')
  },
  {
    path: '/operations_cmdb',
    name: 'cmdb',
    component: () => import(/* webpackChunkName: "resolution/case1" */ '../views/Operations/cmdb.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import(/* webpackChunkName: "news" */ '../views/news.vue')
  },
  {
    path: '/article1',
    name: 'article1',
    component: () => import(/* webpackChunkName: "article1" */ '../views/news/article1.vue')
  },
  {
    path: '/article2',
    name: 'article2',
    component: () => import(/* webpackChunkName: "article2" */ '../views/news/article2.vue')
  },
  {
    path: '/article3',
    name: 'article3',
    component: () => import(/* webpackChunkName: "article3" */ '../views/news/article3.vue')
  },
  {
    path: '/article4',
    name: 'article4',
    component: () => import(/* webpackChunkName: "article4" */ '../views/news/article4.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue')
  },
  {
    path: '*',
    redirect: '/index'
  }
]
const scrollBehavior = () => ({ y: 0 })
const router = new VueRouter({
  routes, scrollBehavior
})

export default router
